<template  >

<div ref="size_map">
  <img class="map" 
    :src="map_location" 
    @click="set_camera_coordinate"
  >
  <div v-if="showModal && deleteModal==false">
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper" :style="{'left': coordinates_for_modal_selections.x +'%', 'top':coordinates_for_modal_selections.y+'px'}">
          <div class="modal-container">
            <div class="modal-header text">
              <slot name="header">
                Виберiть камери
              </slot>
            </div>
            <div class="modal-body">
              <div
                class="modal-cameras-list"
                v-for="camera in not_in_list_points" 
                :key='camera'
                @click="selected_camera=camera"
              >
                <button class="text camera-select">
                  {{camera.camera_info[0].name}}
                </button>  
                  
              </div>
            </div>
            <div class="modal-footer">
              <slot name="footer">
                <button class="cancel" @click="selected_camera=null, showModal = !showModal">
                  Вiдмiнити
                </button>
                <button class="submit" @click="save_position">
                  Зберегти
                </button>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
  <div v-if="deleteModal"  
    class="modal-wrapper" 
    :style="{'left':'30%', 'top': selected_camera.camera_info[0].map_position_y - 3 +'%'}"
  >
    <transition name="modals">   
      <div class="modal-container-d">
        <div class="modal-header text">
          <slot name="header">
            Видалення камери
          </slot>
        </div>
        <div class="modal-body-d">
          Видалити камеру з карти?
        </div>
        <div class="modal-footer">
          <slot name="footer">
            <button class="cancel" @click="deleteModal = !deleteModal">
              Вiдмiнити
            </button>
            <button class="submit" @click="remove_point(selected_camera)">
              Видалити
            </button>
          </slot>
        </div>
      </div>
    </transition>
  </div>

  <div v-for="point in points" :key="point.camera_code" class="point"
    @mouseover="hover_camera_info(point)" 
    @mouseleave="show_camera_info = false" 
    :style="{'left':point.camera_info[0].map_position_x+'%', 'top': point.camera_info[0].map_position_y+'%'}"  
  > 
    <div class="block-delete-point">
      <div class="delete-point" 
        @click="deleteModal = !deleteModal, selected_camera=point"  
      >
        &times;
      </div>
    </div> 
      
    <img :src="camera_img" class="camera_img" @click="get_stream(point)">
  </div>

  <div class="hover_camera_info"
    v-if="show_camera_info"
    :style="{'left':koef_hover_position.x+'px', 'top': koef_hover_position.y+'px'}"
  > 
    <div v-if="$refs.size_map.clientWidth > 600" >
      <div class="title-camera-info text">
        {{camera_info_hover.camera_info[0].name}}
      </div>
      <img :src="camera_info_hover.imgurl" class="info_img">
    </div>  
  </div>
</div>
</template>

<script>
  
  import camera_img from '../assets/images/camera/camera_img.png'

  export default {

    name: 'MapLocationComponent',

    props: ['map_location', 'cameras_list', 'stream_url', 'new_camera_position_in_map'],

    data() {
      return {
        camera_img: camera_img,
        points: [],
        not_in_list_points: [],
        show_camera_info: false,
        camera_info_hover: null,
        showModal: false,
        deleteModal:false,
        coordinates_for_add_camera: {
          x:null,
          y:null
        },
        coordinates_for_modal_selections: {
          x: 30,
          y: 0
        },
        selected_camera: null,
        map_size: {
          width:null,
          height:null,
        },
        koef_hover_position: {
          x: 0,
          y: 0
        },
      }
    },

    mounted() {
      this.distribute_points()
    },

    methods: {
      distribute_points () {
        for (let camera in this.cameras_list) {
          if (this.cameras_list[camera].camera_info[0].map_position_x != null && this.cameras_list[camera].camera_info[0].map_position_y != null) {
            this.points.push(this.cameras_list[camera])
          } else {
            this.not_in_list_points.push(this.cameras_list[camera])
          }
        }
      },

      set_camera_coordinate(event){
        if (this.not_in_list_points.length != 0) {
          // console.log(event.srcElement.clientWidth)
          this.coordinates_for_add_camera.x = event.offsetX/event.srcElement.clientWidth*100
          this.coordinates_for_add_camera.y= event.offsetY/event.srcElement.clientHeight*100
          
          // modal coordenate
          if (event.view.parent.innerHeight < event.clientY + 400) {
            this.coordinates_for_modal_selections.y = event.offsetY - 350
          } 
          else {
            this.coordinates_for_modal_selections.y = event.offsetY
          }

          this.showModal = !this.showModal
        }
      },

      save_position() {
        if (this.selected_camera != null) {

          // if x position > 94
          if (this.coordinates_for_add_camera.x > 94) {
            this.coordinates_for_add_camera.x = 94
          }

          // if y position > 94
          if (this.coordinates_for_add_camera.y > 95) {
            this.coordinates_for_add_camera.y = 95
          }

          this.new_camera_position_in_map ({
            method:'create',
            camera_code:this.selected_camera.camera_code,
            map_position_x:parseInt(this.coordinates_for_add_camera.x),
            map_position_y:parseInt(this.coordinates_for_add_camera.y)
          })
          
          for (let camera in this.not_in_list_points) {
            if (this.not_in_list_points[camera]['camera_code'] === this.selected_camera.camera_code) {
              this.not_in_list_points.splice(camera, 1);
            }
          }
          this.points.push(this.selected_camera)
          this.selected_camera = null
        }
        this.showModal = !this.showModal
      },

      remove_point(point) {
        this.new_camera_position_in_map ({
            method:'delete',
            camera_code:point.camera_code,
          })

        this.not_in_list_points.push(point)

        for (let camera in this.points) {
          if (this.points[camera]['camera_code'] === point.camera_code) {
            this.points.splice(camera, 1);
          }
        }
        this.deleteModal = !this.deleteModal
      },

      get_stream (value) {
        this.stream_url({
          value:value
        })
        window.scrollTo({
        top: 0,
       })
      },

      hover_camera_info(point){

        this.map_size.width = this.$refs.size_map.clientWidth
        this.map_size.height = this.$refs.size_map.clientHeight  

        this.koef_hover_position.x = point.camera_info[0].map_position_x*this.map_size.width/100
        this.koef_hover_position.y = point.camera_info[0].map_position_y*this.map_size.height/100

        // console.log( this.map_size.width , this.map_size.height)

        this.show_camera_info = true

        // defoult        
        this.koef_hover_position.x += 42 
        this.koef_hover_position.y

        // bottom side and left side
        if (point.camera_info[0].map_position_x < 10 && point.camera_info[0].map_position_y > 80) {
          this.koef_hover_position.y -= 80
        }

        // bottom side and right side
        else if (point.camera_info[0].map_position_x > 80 && point.camera_info[0].map_position_y > 80) {
          this.koef_hover_position.x -= 188
          this.koef_hover_position.y -= 80
        }

        // right side
        else if (point.camera_info[0].map_position_x > 80) {
           this.koef_hover_position.x -= 188
        }

        // bottom side
        else if (point.camera_info[0].map_position_y > 85) {
          this.koef_hover_position.y -= 80 
        }

        this.camera_info_hover = point

      }
    },
}
</script>

<style scoped>


  .map{
    width: 100%;
    height: 100%;
  }


  .point {
    position:absolute;
    z-index: 100;
    cursor: pointer;
    max-width: 100%
  }

  .block-delete-point{
    position:absolute;
    margin-left: 30px;
    margin-top: -2px;
    cursor: pointer;
    z-index: 101;
    float: right;
  }

  .camera_img {
    width: 100%;
  }

  .hover_camera_info {
    width: 150px;
    z-index: 120;
    position:absolute;
  }

  .title-camera-info {
    font-size: 14px;
    background-color: #383838;
    padding: 5px;
    border-radius: 5px 5px 0 0;
  }

  .info_img {
    width: 150px;
  }


/* Modal for add point */

  .modal-wrapper {
    position:absolute;
    display: inline-block;
    z-index: 200;
  }

  .modal-container {
    width: 280px;
    margin: 0px auto;
    padding: 20px 30px;
    background-color: rgb(240, 240, 240);
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
  }
  
  .modal-header{
    margin-top: 0;
    color: black;
    text-align: center;
    font-size: 18px;
    padding-bottom: 10px;
  }
  
  .modal-body {
    padding: 20px 0 5px 0;
    overflow: auto;
    height: 200px;
    border: 1px solid #848484;
  }

  .modal-cameras-list {
    text-align: center;
  }

  .camera-select {
    font-size: 14px;
    width: 220px;
    border: none;
    min-height: 31px;
    max-height: 70px;
    cursor: pointer;
    margin-bottom: 10px;
    background: #848484;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 5px;
  }

  .camera-select:focus {
    background: #383838;
  }

  .modal-default-button {
    width: 100px;
    height: 30px;
    color: black;
    justify-self: center;
  }

  .cancel {
    justify-self: center;
    width: 122px;
    height: 31px;
    background: #848484;
    border-radius: 10px;
    display: inline-block;
    border: none;
    cursor: pointer;
    transition-duration: 0.4s;
    text-align: center;
    font-size: 14px;
    line-height: 16px;
    font-weight: bold;
    margin-right: 5px;
  }

  .submit {
    justify-self: center;
    width: 122px;
    height: 31px;
    background: #83931B;
    border-radius: 10px;
    display: inline-block;
    border: none;
    cursor: pointer;
    transition-duration: 0.4s;
    text-align: center;
    font-size: 14px;
    line-height: 16px;
    font-weight: bold;
  }

  .submit:hover {
    background-color: #647014;
  }

  .submit:focus {
    background-color: #647014;
  }

  .cancel:hover {
    background-color: #5e5e5e;
  }
    
  .modal-footer { 
    margin-top: 10px;
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
 
  .modal-enter {
    opacity: 0;
  }
  
  .modal-leave-active {
    opacity: 0;
  }
  
  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  .modal-container-d {
    width: 310px;
    margin: 0px auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }
    
  .modal-body-d {
    margin: 20px 0;
    color: black;
    line-height: 1.5;
  }

  @media (max-width: 900px) {

  .hover_camera_info {
    width: 120px;
  }

  .info_img {
    width: 120px;
  }

  .point {
     grid-template-columns: 1fr auto;
  }

  .title-camera-info {
      font-size: 12px
  }
 
}

@media (max-width: 600px) {

  .point {
     grid-template-columns: 1fr auto;
  }

  .camera_img {
    width: 20px;
  }

  .block-delete-point{
    margin-left: 15px;
    margin-top: -8px;
  }

  .hover_camera_info {
    width: 80px;
  }

  .info_img {
    width: 80px;
  }

  .title-camera-info {
    font-size:10px;
  }

  .modal-wrapper {
    left: 10% !important;
    }
  
  .modal-container, .modal-container-d {
    padding: 10px 20px;
    width: 250px;
  }
 
}

@media (max-width: 500px) {
  .camera_img {
    width: 18px;
  }

  .block-delete-point{
    margin-left: 14px;
    margin-top: -6px;
  }

}

@media (max-width: 400px) {
  .modal-wrapper {
    left: 6% !important;
  }

  .modal-container, .modal-container-d {
    padding: 5px 10px;
  }

}

</style>
